import { BcmDepartment, BcmDepartmentDto } from '@shared/models/bcm-department';
import { tryParseDate } from '@shared/functions/try-parse-date';

export const BCM_COST_CENTER_OVERHEAD_SURCHARGE_MIN = 0;
export const BCM_COST_CENTER_OVERHEAD_SURCHARGE_MAX = 999.99;

export function parseCostCenterOverheadSurchargePercent(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const numericValue = typeof value === 'number'
        ? value
        : Number(String(value).replace(',', '.'));

    return Number.isFinite(numericValue) ? numericValue : null;
}

export interface BcmCostCenterDepartmentDto {
    id: number;
    name: string;
}

export interface BcmCostCenterDto {
    id: number;
    name: string;
    abbreviation: string;
    number: string;
    description: string;
    overheadSurchargePercent?: number | null;
    department?: BcmCostCenterDepartmentDto | null;

    deletedOn: string;
    deletedBy: string;
    insertedOn: string;
    insertedBy: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
}

export class BcmCostCenter {
    id: number;
    name: string;
    abbreviation: string;
    number: string;
    description: string;
    overheadSurchargePercent: number | null;
    department: BcmDepartment | null;

    deletedOn: Date | null;
    deletedBy: string;
    insertedOn: Date | null;
    insertedBy: string;
    lastUpdatedOn: Date | null;
    lastUpdatedBy: string;

    constructor(costCenterDto: BcmCostCenterDto = {} as BcmCostCenterDto) {
        this.id = costCenterDto.id;
        this.name = costCenterDto.name;
        this.abbreviation = costCenterDto.abbreviation;
        this.number = costCenterDto.number;
        this.description = costCenterDto.description;
        this.overheadSurchargePercent = parseCostCenterOverheadSurchargePercent(costCenterDto.overheadSurchargePercent);
        this.department = costCenterDto.department
            ? new BcmDepartment(costCenterDto.department as BcmDepartmentDto)
            : null;

        this.deletedOn = tryParseDate(costCenterDto.deletedOn);
        this.deletedBy = costCenterDto.deletedBy;
        this.insertedOn = tryParseDate(costCenterDto.insertedOn);
        this.insertedBy = costCenterDto.insertedBy;
        this.lastUpdatedOn = tryParseDate(costCenterDto.lastUpdatedOn);
        this.lastUpdatedBy = costCenterDto.lastUpdatedBy;
    }

    toString(): string {
        return [
            this.name,
            this.abbreviation ? `(${this.abbreviation})` : undefined
        ].filter(_ => !!_).join(' ');
    }
}
